// pwa-src/components/cards/playerCards/v2/PlayerCard.ts
import { Attribute, CalculatedPlayer, LookupDetails } from '@alienheadwars/football-card-manager-model'; // Added Attribute import
import { Stack } from '@mui/material';
import React from 'react';
// import Avatar as MUIavatar from '@mui/material/Avatar';

//TODO move away from css files
import '@fontsource/norwester';
import { Overlay } from '../../base/overlay/Overlay';
import { CardDimensions, LargeCard, SmallCard } from './CardDimensions';
import { PlayerCardComponent } from './PlayerCard';
import { TutorialContext } from '../../base/tutorial/tutorialTracker/TutorialTracker';

interface ExpandablePlayerCardProps {
    key?: string,
    player: CalculatedPlayer | LookupDetails;
    dimensions?: CardDimensions;
    onClick?(): void
    actions?: React.ReactNode
    // margin?: boolean
    attributeSet?: Attribute[]
    blockExpand?: boolean
}

export const ExpandablePlayerCard = (props: ExpandablePlayerCardProps) => {

    const [viewPlayer, setViewPlayer] = React.useState(false)

    const tutorialContext = React.useContext(TutorialContext)


    //Only exit out if there are no tutorials showing
    const overlayOnclick = () => {
        if (!tutorialContext.currentTutorial) {
            setViewPlayer(false)
        }
    }


    return <>{viewPlayer ? <Overlay onclick={overlayOnclick} usePortal>
        <Stack>
            <PlayerCardComponent key={props.key} player={props.player} cardDimensions={LargeCard} showTutorials={true} />
            {props.actions}
        </Stack>
    </Overlay> : ''}
        <PlayerCardComponent {...props} cardDimensions={props.dimensions ?? SmallCard} onClick={() => {
            if (!props.blockExpand) {
                setViewPlayer(true)
            }
            if (props.onClick) {
                props.onClick()
            }
        }} />
    </>

}